import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const CampaignPerformanceReport = {
  name: 'campaignPerformanceReport',
  state: {
    loading: false,
    error: '',
    data: null,
    lastQuery: null,
  },
  reducers: {
    requestStarted(state, payload) {
      return {
        ...state,
        loading: true,
        error: '',
        lastQuery: payload || null,
      };
    },
    requestSucceeded(state, payload) {
      return {
        ...state,
        loading: false,
        error: '',
        data: payload,
      };
    },
    requestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload || 'Failed to load campaign performance report',
      };
    },
    clearState(state) {
      return {
        ...state,
        loading: false,
        error: '',
        data: null,
        lastQuery: null,
      };
    },
  },
  effects: (dispatch) => ({
    async fetch(data) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const start_date = data?.start_date;
      const end_date = data?.end_date;
      const view = data?.view || 'dso';
      const camp_id = data?.camp_id;
      const org_id = data?.org_id || userInfo?.org_id;
      const rawDisplayId = data?.display_id;
      const hasDisplayFilter =
        rawDisplayId != null && rawDisplayId !== '';

      if (!start_date || !end_date || !camp_id || !org_id) {
        this.requestFailed('Missing required report query fields');
        return;
      }

      try {
        const queryBase = [
          `start_date=${encodeURIComponent(start_date)}`,
          `end_date=${encodeURIComponent(end_date)}`,
          `view=${encodeURIComponent(view)}`,
          `camp_id=${encodeURIComponent(camp_id)}`,
          `org_id=${encodeURIComponent(org_id)}`,
        ];
        if (hasDisplayFilter) {
          queryBase.push(`display_id=${encodeURIComponent(rawDisplayId)}`);
        }
        const query = queryBase.join('&');
        this.requestStarted({
          start_date,
          end_date,
          view,
          camp_id,
          org_id,
          ...(hasDisplayFilter ? { display_id: rawDisplayId } : {}),
        });
        const response = await http.get(`savvy/campaigns/reports/campaign-performance?${query}`);
        const payload = response?.data?.data ?? response?.data ?? null;
        this.requestSucceeded(payload);
      } catch (err) {
        const message = err?.response?.data?.message || err?.message || 'Failed to load campaign performance report';
        this.requestFailed(message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(message),
            show: true,
          },
        });
      }
    },
  }),
};

export default CampaignPerformanceReport;
